// extracted by mini-css-extract-plugin
module.exports = {"page-spinner":"index__page-spinner___L0aWs","pageSpinner":"index__page-spinner___L0aWs","spin":"index__spin___ujLE9","small":"index__small___upMPi"};